import {
  PermissionsKeys,
  type AnyPermissionsKey,
} from "components/permissions/permission-keys";
import { Megaphone, type LucideIcon } from "lucide-react";
import * as Routes from "routes";

interface DashboardAnnouncement {
  id: string;
  icon: LucideIcon;
  title: string;
  description: string;
  appearance: {
    backgroundClassName: string;
    foregroundClassName: string;
  };
  action?: {
    label: string;
    to: string;
    permission?: AnyPermissionsKey;
  };
}

export const dashboardAnnouncement: DashboardAnnouncement = {
  // Use a new ID for each announcement so dismissed notices can be replaced.
  id: "subscription-change",
  icon: Megaphone,
  title: "Changes to Hub subscriptions are on the way.",
  description:
    "We’re introducing a Starter plan and updating Free tier credits.",
  appearance: {
    backgroundClassName: "bg-linear-to-r from-primary to-primary/70",
    foregroundClassName: "text-white",
  },
  action: {
    label: "Manage Subscription",
    to: Routes.orgManageSubscription,
    permission: PermissionsKeys.subscriptionUpdate,
  },
};
